module.exports = __webpack_public_path__ + "static/Service-hero-how-can-small-restaurants-37dbf60c4c90680c064e268f84d97d67.jpg";